/**
 * Detail Store — Scroll Restore (smooth)
 * Saves scroll Y + document height on collection/search pages.
 * On back navigation: reserves height with invisible spacer, scrolls once,
 * lets real content fill in behind the spacer without visible jumps.
 * Targets iOS Safari bfcache scroll-reset bug.
 */
(function () {
  var TRACKED = /^\/(collections|search)(\/|\?|$)/;
  if (!TRACKED.test(location.pathname)) return;

  var key = 'dt:sr:' + location.pathname + location.search;
  var keyH = key + ':h';

  var save = function () {
    try {
      sessionStorage.setItem(key, String(window.scrollY || window.pageYOffset || 0));
      sessionStorage.setItem(keyH, String(document.documentElement.scrollHeight || 0));
    } catch (e) {}
  };

  // Throttled save on scroll
  var t;
  window.addEventListener(
    'scroll',
    function () {
      if (t) return;
      t = setTimeout(function () {
        save();
        t = null;
      }, 150);
    },
    { passive: true }
  );

  window.addEventListener('pagehide', save);
  window.addEventListener('beforeunload', save);

  window.addEventListener('pageshow', function () {
    var savedY = sessionStorage.getItem(key);
    if (savedY == null) return;
    var y = parseInt(savedY, 10);
    if (isNaN(y) || y < 60) return;

    var prevH = parseInt(sessionStorage.getItem(keyH) || '0', 10);
    var needed = Math.max(y + window.innerHeight + 100, prevH);

    // Invisible spacer at end of body — reserves height so scrollTo lands correctly
    // even before lazy images / async content load
    var spacer = document.createElement('div');
    spacer.setAttribute('data-dt-spacer', '1');
    spacer.style.cssText =
      'height:' + needed + 'px;visibility:hidden;pointer-events:none;margin:0;padding:0;';
    document.body.appendChild(spacer);

    // Scroll once, instantly
    window.scrollTo(0, y);

    // Poll via rAF until real content (excluding spacer) is tall enough,
    // then remove the spacer cleanly. Bail after 2.5s.
    var start = performance.now();
    var lastDriftCheck = 0;

    var poll = function (now) {
      var natural = document.body.scrollHeight - spacer.offsetHeight;

      // Re-correct scroll occasionally if browser tries to reset to top
      if (now - lastDriftCheck > 80) {
        var current = window.scrollY || window.pageYOffset || 0;
        if (Math.abs(current - y) > 12 && current < y) {
          window.scrollTo(0, y);
        }
        lastDriftCheck = now;
      }

      if (natural >= needed || now - start > 2500) {
        spacer.remove();
        // Final correction in case removal triggered any reflow
        var c = window.scrollY || window.pageYOffset || 0;
        if (Math.abs(c - y) > 12 && c < y) {
          window.scrollTo(0, y);
        }
        return;
      }

      requestAnimationFrame(poll);
    };
    requestAnimationFrame(poll);
  });
})();
